import React from 'react';
import { Switch } from 'react-router-dom';
import { home } from '../config';
import Route from './routes';
import SignIn from '../pages/SignIn';
import Sobre from '../pages/Sobre';
import SignInAdmin from '../pages/SignInAdmin';
import SignUp from '../pages/SignUp';
import RecoverPassword from '../pages/RecoverPassword';
import ResetPassword from '../pages/ResetPassword';
import Products from '../pages/Products';

import VideosDashboard from '../pages/VideosDashboard';
import Dashboard from '../pages/DashboardPages';

import Home from '../pages/Home';
import AreaExposicao from '../pages/AreaExposicao';
import Expositor from '../pages/Expositor';
import Galeria from '../pages/Galeria';
 
import SigninExpositor from '../pages/SigninExpositor';
import Program from '../pages/Program';
import Poster from '../pages/Poster';

import Speakers from '../pages/Speakers';
import Zoom from '../components/ZoomStarter';
import SpeakerLink from '../pages/SpeakerLink';
import ModeratorLink from '../pages/ModeratorLink';
import Validate from '../pages/DashboardPages/features/AuthIntegration';
import HomeApplication from '../PagesApplication/HomeApplication';
import GreenRoom from '../pages/GreenRoom';
import UserHome from '../pages/DashboardUserPages/Pages/Home';
import FileGallerys from '../pages/FileGallery';
import Sponsors from '../pages/Sponsors';
import ProgramTheme from '../PagesApplication/HomeApplication/modules/Program';
import Certificados from '../pages/Certificados';
import SurveyView from '../pages/DashboardPages/features/SurveyByURL';
import CientificLibraryAuthor from '../pages/CientificLibraryAuthor';
import CientificLibrary from '../pages/CientificLibrary';
import EventsPages from '../PagesApplication/HomeApplication/modules/Paginas';
import SelecionarData from '../pages/SelecionarDatas';
import CertificadosValidar from '../pages/CertificadosValidar';
import ListarEventos from '../pages/ListarEventos';
import Termos from '../pages/Termos';
import UserDashboard from '../pages/DashboardUserPages/Pages/Home';
import { useConfiguration } from 'src/hooks/Configuration';
import ProductsWithTicket from 'src/pages/ProductsSimplifiedWithTicket2';
import PaymentConfirmation from 'src/pages/ProductsSimplifiedWithTicket2/modules/PaymentConfirmation';
import AreaAtendimento from 'src/pages/AreaAtendimento';
import SignInEquipe from 'src/pages/SignInEquipe';

import { Recibo } from '../pages/DashboardPages/features/Recibo';




const ValidPaths = {
  SignIn,
  SignInAdmin,
  SignUp,
  RecoverPassword,
  ResetPassword,
  Products,
  VideosDashboard,

  Home,
  Sobre,
};

const Routes: React.FC = () => {
  const { configuration } = useConfiguration();
  return (
    <Switch>
      <Route

        path="/"
        exact
        component={ValidPaths[home] ? ValidPaths[home] : Home}
      />

      <Route path="/validar-certificado/:hash" component={CertificadosValidar} />

      <Route
        isPrivate
        path="/user-dashboard"
        component={UserHome}
      />

  

      <Route path="/app/:projectHash/recibo/:hash" component={Recibo} />
      <Route

        path="/app/:projectHash/area-de-atendimento"
        component={AreaAtendimento}
      />

      <Route path="/app/:projectHash/login-atendimento" component={SignInEquipe} />

      <Route path="/biblioteca-cientifica/autores" component={CientificLibraryAuthor} />
      <Route path="/biblioteca-cientifica/artigos/:posterid" component={CientificLibrary} />
      <Route path="/biblioteca-cientifica/categoria/:eixo" component={CientificLibrary} />
      <Route path="/biblioteca-cientifica" component={CientificLibrary} />

      <Route path="/eventos/:categoryName" component={ListarEventos} />
      <Route path="/eventos" component={ListarEventos} />


      <Route path="/app/:projectHash/arquivos-de-apoio" component={FileGallerys} />

      <Route path="/app/:projectHash/programacao" component={ProgramTheme} />
      <Route path="/app/:projectHash/paginas/:url" component={EventsPages} />
      <Route path="/app/:projectHash/login/" component={SignIn} />
      <Route path="/login" component={SignIn} />

      <Route path="/app/:projectHash/event/:eventHash/survey/:survey_id" component={SurveyView} />
      <Route path="/app/:projectHash/survey/:survey_id" component={SurveyView} />

      <Route path="/app/:projectHash/event/:eventHash/login/" component={SignIn} />

      <Route path="/app/:projectHash/event/:eventHash/arquivos-de-apoio" component={FileGallerys} />
      <Route path="/app/:projectHash/event/:eventHash/certificados" component={Certificados} />


      <Route path="/app/:projectHash/event/:eventHash/palestrantes" component={Speakers} />
      <Route path="/app/:projectHash/event/:eventHash/patrocinadores" component={Sponsors} />
      <Route path="/app/:projectHash/event/:eventHash/inscricao" component={ProductsWithTicket} />
      <Route path="/app/:projectHash/selecionar-data" component={SelecionarData} />
      <Route path="/app/:projectHash/inscricao/:productId" component={ProductsWithTicket} />
      <Route path="/app/:projectHash/certificados" component={Certificados} />

      <Route path="/app/:projectHash/palestrantes" component={Speakers} />
      <Route path="/app/:projectHash/patrocinadores" component={Sponsors} />
      <Route path="/app/:projectHash/inscricao" component={ProductsWithTicket} />
      <Route path="/inscricao" component={ProductsWithTicket} />

      <Route

        path="/app/:projectHash/event/:eventHash/dashboard/:videoIdItem"
        component={configuration?.current_event_id_response?.event_type === 'Presencial' ? UserDashboard : VideosDashboard}
      />
      <Route path="/app/:projectHash/payment/v4/success/:payment_hash" component={PaymentConfirmation} />
      <Route

        path="/app/:projectHash/event/:eventHash/dashboard/"
        component={configuration?.current_event_id_response?.event_type === 'Presencial' ? UserDashboard : VideosDashboard}
      />
      <Route

        path="/app/:projectHash/dashboard/:videoIdItem"
        component={configuration?.current_event_id_response?.event_type === 'Presencial' ? UserDashboard : VideosDashboard}
      />
      <Route

        path="/app/:projectHash/dashboard/"
        component={configuration?.current_event_id_response?.event_type === 'Presencial' ? UserDashboard : VideosDashboard}
      />

      <Route template={'page'} isPrivate isSecret path="/app/:projectHash/green-room/:id" component={GreenRoom} />

      <Route isPrivate path="/app/:projectHash/poster" component={Poster} />

      <Route path="/app/:projectHash/event/:eventHash" component={HomeApplication} />
      <Route path="/app/:projectHash" component={HomeApplication} />

      <Route template="client" path="/validate/:hash" component={Validate} />
      <Route template="client" path="/events/access/:hash" component={SpeakerLink} />
      <Route path="/zoom" component={Zoom} />

      <Route path="/moderator/access/:projectHash/:hash" component={ModeratorLink} />

      <Route path="/exposicao" component={AreaExposicao} />
      <Route path="/termos" component={Termos} />
      <Route template="client" path="/admin" component={SignInAdmin} />
      <Route isPrivate path="/login_expositor" component={SigninExpositor} />

 
      <Route
        isPrivate
        path="/galeria/:link_name"
        template="page"
        component={Galeria}
      />
  


      <Route
        path="/manager/:tab/:projectHash/:eventHash"
        template="dashboard"
        isPrivate
        isSecret
        component={Dashboard}
      />

      <Route
        path="/manager/:tab/:projectHash"
        template="dashboard"
        isPrivate
        isSecret
        component={Dashboard}
      />

      <Route
        path="/manager/:tab"
        template="dashboard"
        isPrivate
        isSecret
        component={Dashboard}
      />
      <Route
        path="/manager"
        template="dashboard"
        isPrivate
        exact
        isSecret
        component={Dashboard}
      />


    </Switch>
  );
};

export default Routes;
